/*jshint esversion: 6*/
import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import routes from './routes';
import VModal from 'vue-js-modal';
import VueCookies from 'vue-cookies'
import vClickOutside from 'v-click-outside'
// import './registerServiceWorker';
window.$ = window.jQuery = require('jquery');


Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(VModal, { dynamic: true });
Vue.use({
    install: function(Vue){
        Vue.prototype.$jQuery = require('jquery'); // 
    }
});
Vue.use(VueCookies);
Vue.use(vClickOutside);

const router = new VueRouter({
	// mode: 'history',
	routes
});

new Vue({
	router: router,
	render: h => h(App)
}).$mount('#app');


// function scaleElement(el) {
// 	var styles = window.getComputedStyle(el);
// 	var height = parseInt(styles.getPropertyValue('min-height'));
// 	var width = parseInt(styles.getPropertyValue('min-width'));

// 	if (window.innerWidth >= width && window.innerHeight >= height) {
// 		el.style.transform = 'scale(1)';
// 		return;
// 	}

// 	var sW = window.innerWidth / width;
// 	var sH = window.innerHeight / height;

// 	var scale = sW > sH ? sH : sW;

// 	el.style.transform = 'scale(' + scale + ')';
// }

// var box = document.querySelector('.GlobalContainer');

// scaleElement(box);

// window.addEventListener('resize', function() {
// 	scaleElement(box);
// });

/* eslint-disable */

var $el = $(".PageContainer");
var $wrapper = $(".GlobalContainer");
var scale;
var elHeight = $el.outerHeight();
var elWidth = $el.outerWidth();


$(window).resize(function () {
  var starterData = {
    size: {
      width: $wrapper.width(),
      height: $wrapper.height()
    }
  }

  doResize(starterData);
});



function doResize(ui) {
  scale = Math.min(
    ui.size.height / elHeight,
    ui.size.width / elWidth

  );

  $el.css({
    transform: "translate(-50%, -50%) " + "scale(" + scale + ")",
  });


}

var starterData = {
  size: {
    width: $wrapper.width(),
    height: $wrapper.height()
  }
}
doResize(starterData);

// eslint-disable-next-line
// var win = nw.Window.get();

// document.onkeyup = function (event) {
// 	if (event.which == 122) {

// 	win.toggleFullscreen();

// 	}
// };